import { useState } from "react";
import { adminExportUrl } from "../../api";

const FILES: Array<{ kind: string; label: string; desc: string }> = [
  { kind: "volunteers.csv", label: "所有志工填寫資料", desc: "每位志工一列，含身分、狀態、總時數、已選場次。" },
  { kind: "event-rosters.csv", label: "各場次志工名單", desc: "每個場次 × 每位志工一列，可直接依場次分組。" },
  { kind: "under-hours.csv", label: "未達最低時數名單", desc: "總服務時數尚未達門檻的志工。" },
  { kind: "not-submitted.csv", label: "尚未最終確認名單", desc: "仍為草稿、尚未送出最終確認的志工。" },
];

export default function ExportTab() {
  const [busy, setBusy] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  async function download(kind: string) {
    setBusy(kind);
    setErr(null);
    try {
      const res = await fetch(adminExportUrl(kind), { credentials: "include" });
      if (!res.ok) throw new Error(`匯出失敗（${res.status}）`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = kind;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "匯出失敗");
    } finally {
      setBusy(null);
    }
  }

  return (
    <div>
      <h3>CSV 匯出</h3>
      <p className="muted">檔案為 UTF-8（含 BOM），可直接用 Excel 開啟，中文不會亂碼。</p>
      {err && <div className="alert err">{err}</div>}
      {FILES.map((f) => (
        <div className="card" key={f.kind} style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ flex: 1 }}>
            <strong>{f.label}</strong>
            <div className="muted">{f.desc}</div>
          </div>
          <button className="btn primary sm" disabled={busy === f.kind} onClick={() => download(f.kind)}>
            {busy === f.kind ? "產生中…" : "下載 CSV"}
          </button>
        </div>
      ))}
    </div>
  );
}
